// https://vuex.vuejs.org/en/state.html

const state = () => {
    return {
        menuConfig: [],
        user: {},
        dashboard: {},
        user_permissions: [],
        workflow_permissions: [],
        parameters: {},
        top_menu: [],
        is_loading: false,
        global_errors: [],
        error_message: '',
        alliance: {},
        support_phone: '',
        my_language:'',
        merchant_user_access:''
        // topTabsConfig: [],
        // mainSideBarConfig: [],
        // reportSideBarConfig: [],
        // case_data: {},
        // alliance: {},
        // merchant: {},
        // merchant_hierarchy: [],
        // accounts_settings: {},
        // merchant_relation: {},
        // merchant_sub_groups: [],
        // substatuses: [],
        // merchant_tree: [],
        // users: {},
        // outlet_relation: {},
        // outlet_form_data: {},
        // outlets: [],
        // outletSummary: {},
        // chains: {},
        // billings: {},
        // merchant_ref: '',
        // current_account_parent: {},
        // daily_accounts: [],
        // current_account_type: {},
        // current_account_summary: [],
        // current_account_list: {},
        // maintenance_ref: '',
        // maintenance: {},
        // last_chain_path: '',
        // last_transaction_filter_path: '',
        // last_outlet_transaction_filter_path: '',
        // redirect_to_error_tab: false,
        // last_outlet_paths: {},
        // outletInFocus: {},
        // groupInFocus: {},
        // parameters: {},
        // aml_report: {},
        // risk_report: {},
        // is_loading: false,
        // snapshot_input: {},
        // current_node_type:  '',
        // validation_errors: {},
        // merchant_hierarchy_configuration_templates: {},
        // is_provider: false,
        // logged_in_user_id: '',
    }
}
export default state;